import React from "react";
import "./styles/main.css";
import avatar from "assets/images/profile-picture-girl-1.jpeg";
import Icon from "components/Icon";
import Alert from "./Alert";
import Contact from "./Contact";
import OptionsBtn from "components/OptionsButton";
import { useUsersContext } from "context/usersContext";
import  TopBarFilter  from "../TopBarFilter"
import { useState } from "react";


const Sidebar = () => {
	const { users: contacts } = useUsersContext();
	const [filter, setFilter] = useState('all');
	
	const [searchTerm, setSearchTerm] = useState("");

	const handleChange = (event) => {
		setSearchTerm(event.target.value);
	  };

	

	const filterMap = (value) => {
		console.log('FILTER function got', value);
		switch (value) {
			case 'all':
			  return null
			case 'open':
				return 1
			case 'pending':
			  return 2
			case 'closed':
				return 3
			default:
			  return null
		  }
	}

	console.log('filterMap results:', filterMap(filter))

	console.log('CONTACTS in SIDEBAR:', contacts)


	let filteredContacts = contacts.filter(contact => contact.botStatus === filterMap(filter))


	// if(searchTerm){
	// 	filteredContacts = contacts.filter((filteredContact) =>
	// 	filteredContacts.name.toLowerCase().includes(searchTerm.toLowerCase())
	// 	);
	// }

	if(filteredContacts !== null){
		console.log('filteredContacts DATA: ' + JSON.stringify(filteredContacts))
		if(searchTerm){
			filteredContacts = contacts.filter((contact) => {
				const nameMatch = contact.name.toLowerCase().includes(searchTerm.toLowerCase());
				const phoneMatch = contact.phone.includes(searchTerm);
				const messageMatch = Object.values(contact.messages).some((messagesArray) =>
				messagesArray.some((message) =>
				message.body.includes(searchTerm)
				)
			);

				return nameMatch || phoneMatch || messageMatch;
			});
		}

		console.log('Filtered contacts', filteredContacts)
		console.log('Filtered contacts count', filteredContacts.length)
	}



	const handleFilterChange = (newFilter) => {
	  setFilter(newFilter);
		  // perform filtering on the tickets array based on the new filter value
	};
	return (
		<aside className="sidebar">
			<header className="header">
				<div className="sidebar__avatar-wrapper">
					<img src={avatar} alt="John Doe" className="avatar" />
				</div>
				<div className="sidebar__actions">
					<button className="sidebar__action" aria-label="Status">
						<Icon
							id="status"
							className="sidebar__action-icon sidebar__action-icon--status"
						/>
					</button>
					<button className="sidebar__action" aria-label="New chat">
						<Icon id="chat" className="sidebar__action-icon" />
					</button>
					<OptionsBtn
						className="sidebar__action"
						ariaLabel="Menu"
						iconId="menu"
						iconClassName="sidebar__action-icon"
						options={[
							"New group",
							"Create a room",
							"Profile",
							"Archived",
							"Starred",
							"Settings",
							"Log out",
						]}
					/>
				</div>
			</header>
			{/* <Alert /> */}
			<div className="sidebar__action">
			<TopBarFilter onFilterChange={handleFilterChange} data={contacts}/>
			{/* render the list of tickets based on the filtered array */}
			</div>
			<div className="search-wrapper">
				<div className="search-icons">
					<Icon id="search" className="search-icon" />
					<button className="search__back-btn">
						<Icon id="back" />
					</button>
				</div>
				<input className="search"
				 	placeholder="Search or start a new chat"
				 	value={searchTerm}
 					onChange={handleChange}
				  />
			</div>
			<div className="sidebar__contacts">
				{/* {contacts.map((contact, index) => (
					<Contact key={index} contact={contact} />	
				))
				} */}
				{filteredContacts.map((contact, index) => (
					<Contact key={index} contact={contact} />
				))
			
				}
			</div>
		</aside>
	);
};

export default Sidebar;
